var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 512,
    height: 341.337,
    y: 85.331
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "178.923 189.567 193.579 234.674 241.008 234.674 202.637 262.552 217.294 307.661 178.923 279.782 140.552 307.661 155.208 262.552 116.837 234.674 164.266 234.674"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "271.3 339.593 256.91 329.138 242.522 339.592 248.017 322.678 233.628 312.223 251.414 312.223 256.91 295.307 262.408 312.223 280.193 312.223 265.804 322.677"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "308.837 287.927 291.052 287.927 285.556 304.841 280.06 287.928 262.273 287.927 276.664 277.472 271.166 260.557 285.556 271.01 299.945 260.557 294.449 277.472"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "308.837 224.063 294.449 234.518 299.944 251.432 285.556 240.979 271.166 251.434 276.664 234.517 262.273 224.065 280.061 224.063 285.556 207.147 291.052 224.063"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffda44"
    },
    points: "271.3 172.397 265.805 189.313 280.193 199.766 262.408 199.767 256.91 216.684 251.414 199.766 233.629 199.768 248.018 189.312 242.522 172.396 256.91 182.851"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChi);
export default __webpack_public_path__ + "static/media/chi.ba26b156c3da3cabb28abec4bab40927.svg";
export { ForwardRef as ReactComponent };